import IconReceipt from "@/assets/icons/receipt.svg?react";
import NoData from "@/components/common/NoData.tsx";
import { useTranslation } from "react-i18next";
import type { Voucher } from "../api";
import VoucherCard from "./VoucherCard.tsx";
import VoucherCardSkeleton from "./VoucherCardSkeleton.tsx";

interface VoucherListProps {
  vouchers: Voucher[];
  isLoading: boolean;
  onRedeem: (voucherId: string) => void;
  redeemingId: string | null;
  onShow?: (voucher: Voucher) => void;
  activeTab?: "all" | "mine";
}

export default function VoucherList({
  vouchers,
  isLoading,
  onRedeem,
  redeemingId,
  onShow,
  activeTab = "all",
}: VoucherListProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <VoucherCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (vouchers.length === 0) {
    return (
      <div className="flex-center min-h-[60vh]">
        <NoData
          image={<IconReceipt className="size-12 text-gray-1" />}
          title={
            activeTab === "mine"
              ? t("no_my_vouchers") ||
                "Hozircha sotib olingan voucherlar mavjud emas"
              : t("no_vouchers")
          }
          description={
            activeTab === "mine" ? "" : t("no_vouchers_description")
          }
        />
      </div>
    );
  }

  const sorted = [...vouchers].sort((a, b) => {
    const order: Record<string, number> = {
      AVAILABLE: 0,
      REDEEMED: 1,
      SOLD_OUT: 2,
      EXPIRED: 3,
      USED: 4,
    };
    return (order[a.status] ?? 99) - (order[b.status] ?? 99);
  });

  return (
    <div className="grid grid-cols-2 gap-3">
      {sorted.map((voucher) => (
        <VoucherCard
          key={voucher.id}
          voucher={voucher}
          onRedeem={onRedeem}
          isRedeeming={redeemingId === voucher.id}
          onShow={onShow}
        />
      ))}
    </div>
  );
}
